export class SearchOrganizationResponse {
    Id: string;
    Plan: string;
    PlanId: string;
    Balance: string;
    Name: string;
    ClusterName: string;
    HubspotCompanyId: string;
    DealId: string;
    IsTestContract: boolean;
    Owner: string;
    BlipUrl: string;
    DeskUrl: string;
    PaymentAccount: string;
    BlipSubsidiary: string;
    CreatedAt: Date;
}